import { createLucideIcon } from 'lucide-react';
export const Clock = createLucideIcon('', [
  [
    'path',
    {
      d: 'M17.6569 6.34315C14.5327 3.21895 9.46734 3.21895 6.34315 6.34315C3.21895 9.46734 3.21895 14.5327 6.34315 17.6569C9.46734 20.781 14.5327 20.781 17.6569 17.6569C20.781 14.5327 20.781 9.46734 17.6569 6.34315Z',
      key: '1g2k4n',
    },
  ],
  [
    'path',
    {
      d: 'M18 11H12V6',
      key: 'e8d1ed',
    },
  ],
]);
